(function () {
  'use strict';

  function parseProduct(root) {
    var node = root.querySelector('[data-vg-hbl-product-json]');
    if (!node) return null;
    try {
      var parsed = JSON.parse(node.textContent);
      return parsed && Array.isArray(parsed.options) && Array.isArray(parsed.variants) ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function optionIndex(product, name) {
    return product.options.findIndex(function (option) {
      return String(option.name).toLowerCase() === name;
    });
  }

  function emit(root, name, detail) {
    root.dispatchEvent(new CustomEvent('vg-hbl:' + name, { bubbles: true, detail: detail || {} }));
  }

  function initCarousel(root) {
    var carousel = root.querySelector('[data-vg-hbl-review-carousel]');
    if (!carousel || carousel.dataset.vgHblReady === 'true') return;
    carousel.dataset.vgHblReady = 'true';

    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-vg-hbl-review-slide]'));
    var previous = carousel.querySelector('[data-vg-hbl-review-prev]');
    var next = carousel.querySelector('[data-vg-hbl-review-next]');
    var dotsRoot = carousel.querySelector('[data-vg-hbl-review-dots]');
    var index = 0;
    var touchStart = null;

    if (!slides.length) return;

    slides.forEach(function (_, slideIndex) {
      if (!dotsRoot) return;
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'vg-hbl-buybox__review-dot';
      dot.setAttribute('aria-label', 'Show review ' + (slideIndex + 1));
      dot.addEventListener('click', function () { show(slideIndex, 'dot'); });
      dotsRoot.appendChild(dot);
    });

    function show(nextIndex, source) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) { slide.hidden = slideIndex !== index; });
      if (dotsRoot) {
        Array.prototype.forEach.call(dotsRoot.children, function (dot, dotIndex) {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
      }
      emit(root, 'review-navigation', { index: index, source: source });
    }

    if (previous) previous.addEventListener('click', function () { show(index - 1, 'previous'); });
    if (next) next.addEventListener('click', function () { show(index + 1, 'next'); });
    carousel.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1, 'keyboard'); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1, 'keyboard'); }
    });
    carousel.addEventListener('touchstart', function (event) {
      touchStart = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : null;
    }, { passive: true });
    carousel.addEventListener('touchend', function (event) {
      if (touchStart === null || !event.changedTouches || !event.changedTouches[0]) return;
      var distance = event.changedTouches[0].clientX - touchStart;
      touchStart = null;
      if (Math.abs(distance) < 40) return;
      show(index + (distance < 0 ? 1 : -1), 'swipe');
    }, { passive: true });
    show(0, 'initial');
  }

  function init(root) {
    if (!root || root.dataset.vgHblReady === 'true') return;
    root.dataset.vgHblReady = 'true';

    var product = parseProduct(root);
    var size = root.querySelector('[data-vg-hbl-size]');
    var colors = Array.prototype.slice.call(root.querySelectorAll('[data-vg-hbl-color]'));
    var colorLabel = root.querySelector('[data-vg-hbl-color-label]');
    var hidden = root.querySelector('[data-vg-hbl-variant-id]');
    var button = root.querySelector('[data-vg-hbl-atc]');
    var status = root.querySelector('[data-vg-hbl-status]');
    var price = root.querySelector('[data-vg-hbl-price]');
    var image = root.querySelector('[data-vg-hbl-product-image], .vg-hbl-buybox__image');
    var form = hidden ? hidden.closest('form') : null;
    var formId = form ? form.getAttribute('id') : '';
    var sizeIndex = product ? optionIndex(product, 'size') : -1;
    var colorIndex = product ? Math.max(optionIndex(product, 'color'), optionIndex(product, 'colour')) : -1;

    function disable(message) {
      if (hidden) { hidden.value = ''; hidden.disabled = true; }
      if (button) button.disabled = true;
      if (status) status.textContent = message;
    }

    if (!product || !size || !hidden || !button || !status || !formId || sizeIndex < 0 || colorIndex < 0) {
      disable('Product unavailable');
      initCarousel(root);
      return;
    }

    var sizeValues = product.options[sizeIndex].values || [];
    var existingValues = Array.prototype.map.call(size.options, function (option) { return option.value; });
    sizeValues.forEach(function (value) {
      if (existingValues.indexOf(String(value)) >= 0) return;
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      size.appendChild(option);
    });

    var initialColor = colors.find(function (radio) { return radio.value === 'Gray'; }) || colors[0];
    colors.forEach(function (radio) { radio.checked = radio === initialColor; });
    Array.prototype.forEach.call(size.options, function (option) {
      option.selected = false;
      option.removeAttribute('selected');
    });
    var promptOption = Array.prototype.find.call(size.options, function (option) { return option.value === ''; });
    if (promptOption) {
      promptOption.selected = true;
      promptOption.setAttribute('selected', 'selected');
    }

    function selectedSize() {
      var selected = Array.prototype.find.call(size.options, function (option) { return option.selected; });
      return selected ? selected.value : size.value;
    }

    function selectedColor() {
      var selected = colors.find(function (radio) { return radio.checked; });
      return selected ? selected.value : '';
    }

    function updateVisual(variant) {
      if (!variant) return;
      if (price) price.textContent = variant.price_formatted || '';
      if (image && variant.featured_media) {
        if (variant.featured_media.url) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.setAttribute('src', variant.featured_media.url);
        }
        if (variant.featured_media.alt) image.setAttribute('alt', variant.featured_media.alt);
        if (variant.featured_media.width) image.setAttribute('width', variant.featured_media.width);
        if (variant.featured_media.height) image.setAttribute('height', variant.featured_media.height);
      }
    }

    function resolve() {
      var chosenSize = selectedSize();
      var chosenColor = selectedColor();
      if (colorLabel) colorLabel.textContent = chosenColor;
      if (!chosenSize || !chosenColor) {
        var representative = product.variants.find(function (candidate) {
          return String(candidate.options[colorIndex]) === chosenColor && candidate.available;
        }) || product.variants.find(function (candidate) {
          return String(candidate.options[colorIndex]) === chosenColor;
        });
        updateVisual(representative);
        disable('Choose a size');
        return;
      }

      var variant = product.variants.find(function (candidate) {
        return String(candidate.options[sizeIndex]) === chosenSize && String(candidate.options[colorIndex]) === chosenColor;
      });
      if (!variant) {
        disable('Product unavailable');
        return;
      }

      updateVisual(variant);

      if (!variant.available) {
        disable('Sold out');
        return;
      }

      hidden.value = String(variant.id);
      hidden.disabled = false;
      var productForm = form ? form.closest('product-form') : null;
      if (!button.classList.contains('loading') && !(productForm && productForm.isloading)) button.disabled = false;
      status.textContent = 'In stock';
      emit(root, 'valid-variant-resolved', { variantId: String(variant.id), formId: formId });
    }

    size.addEventListener('change', function () {
      resolve();
    });
    colors.forEach(function (radio) { radio.addEventListener('change', resolve); });
    if (button) button.addEventListener('click', function () {
      if (!button.disabled && hidden.value) emit(root, 'atc-click', { variantId: hidden.value });
    });
    if (form) {
      form.addEventListener('submit', function (event) {
        if (hidden.disabled || !hidden.value) event.preventDefault();
      });
    }

    resolve();
    initCarousel(root);
  }

  function initAll(scope) {
    var target = scope || document;
    Array.prototype.forEach.call(target.querySelectorAll('[data-vg-hbl-buybox]'), init);
  }

  window.VgHblBuybox = { initAll: initAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
}());
